import { productServices } from "../../api/services/products";
import { useSearchParams, useSearchParamsDispatch } from "../../context/SearchParamsContext";

export const useQuerySearcher = () => {
  const searchParamsState = useSearchParams();
  const searchParamsDispatch = useSearchParamsDispatch();
  const { queryFilters, querySearch } = searchParamsState;

  const handleSearch = async () => {
    try {
      searchParamsDispatch({ loading: true });
      const queryParams = getQueryString();
      const data = await productServices.getProductList(queryParams);
      if(data.response){
        searchParamsDispatch({ searchResults: data.response });
      }else{
        searchParamsDispatch({ searchResults: [] });
      }
    } catch (error) {
    } finally {
      searchParamsDispatch({ loading: false });
    }
  };

  const getQueryString = () => {
    const params = [];
    if (querySearch) {
      params.push(`nombre=${encodeURIComponent(querySearch)}`);
    }

    for (const key in queryFilters) {
      if (queryFilters.hasOwnProperty(key)) {
        const value = queryFilters[key];
        if (value) {
          if (key === "tipo") {
            if (value === "fondos") {
              params.push(`tipo=fondos,sicav`);
            } else if (value === "planesindiv") {
              params.push(`tipo=planes&subtipo=planesindiv`);
            } else if (value === "planesasoc") {
              params.push(`tipo=planes&subtipo=planesasoc`);
            } else {
              params.push(
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
              );
            }
          } else {
            params.push(
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            );
          }
        }
      }
    }

    return params.join("&");
  };

  return {
    handleSearch,
  };
};
